
import { WorldCity } from '../types';

// Expansión de Croacia - 70 ciudades adicionales
export const croatiaAdditionalCities: WorldCity[] = [
  { name: 'Split', slug: 'split', population: 178102 },
  { name: 'Rijeka', slug: 'rijeka', population: 128624 },
  { name: 'Osijek', slug: 'osijek', population: 84104 },
  { name: 'Zadar', slug: 'zadar', population: 75062 },
  { name: 'Pula', slug: 'pula', population: 57460 },
  { name: 'Slavonski Brod', slug: 'slavonski-brod', population: 53531 },
  { name: 'Karlovac', slug: 'karlovac', population: 47205 },
  { name: 'Varazdin', slug: 'varazdin', population: 46946 },
  { name: 'Sisak', slug: 'sisak', population: 45061 },
  { name: 'Velika Gorica', slug: 'velika-gorica', population: 63517 },
  { name: 'Dubrovnik', slug: 'dubrovnik', population: 42615 },
  { name: 'Bjelovar', slug: 'bjelovar', population: 40276 },
  { name: 'Vukovar', slug: 'vukovar', population: 26468 },
  { name: 'Koprivnica', slug: 'koprivnica', population: 30854 },
  { name: 'Zapresic', slug: 'zapresic', population: 19644 },
  { name: 'Cakovec', slug: 'cakovec', population: 27820 },
  { name: 'Vinkovci', slug: 'vinkovci', population: 32029 },
  { name: 'Pozega', slug: 'pozega', population: 26248 },
  { name: 'Samobor', slug: 'samobor', population: 37633 },
  { name: 'Sesvete', slug: 'sesvete', population: 70009 },
  { name: 'Dakovo', slug: 'dakovo', population: 27745 },
  { name: 'Pitomaca', slug: 'pitomaca', population: 9090 },
  { name: 'Novi Marof', slug: 'novi-marof', population: 13246 },
  { name: 'Ludbreg', slug: 'ludbreg', population: 8478 },
  { name: 'Ivanec', slug: 'ivanec', population: 13758 },
  { name: 'Lepoglava', slug: 'lepoglava', population: 8052 },
  { name: 'Novi Vinodolski', slug: 'novi-vinodolski', population: 3988 },
  { name: 'Senj', slug: 'senj', population: 8132 },
  { name: 'Crikvenica', slug: 'crikvenica', population: 11122 },
  { name: 'Opatija', slug: 'opatija', population: 11659 },
  { name: 'Kastav', slug: 'kastav', population: 10472 },
  { name: 'Delnice', slug: 'delnice', population: 5952 },
  { name: 'Vrbovsko', slug: 'vrbovsko', population: 4473 },
  { name: 'Fuzine', slug: 'fuzine', population: 1681 },
  { name: 'Skrad', slug: 'skrad', population: 1045 },
  { name: 'Lokve', slug: 'lokve', population: 1049 },
  { name: 'Mrkopalj', slug: 'mrkopalj', population: 1218 },
  { name: 'Ravna Gora', slug: 'ravna-gora', population: 1598 },
  { name: 'Cabar', slug: 'cabar', population: 3770 },
  { name: 'Gerovo', slug: 'gerovo', population: 237 },
  { name: 'Brod Moravice', slug: 'brod-moravice', population: 811 },
  { name: 'Vrbnik', slug: 'vrbnik', population: 1260 },
  { name: 'Omisalj', slug: 'omisalj', population: 2998 },
  { name: 'Malinska-Dubasnica', slug: 'malinska-dubasnica', population: 3134 },
  { name: 'Punat', slug: 'punat', population: 1876 },
  { name: 'Baška', slug: 'baska', population: 1674 },
  { name: 'Krk', slug: 'krk', population: 3065 },
  { name: 'Dobrinj', slug: 'dobrinj', population: 2078 },
  { name: 'Rab', slug: 'rab', population: 8065 },
  { name: 'Lopar', slug: 'lopar', population: 1263 },
  { name: 'Novalja', slug: 'novalja', population: 3663 },
  { name: 'Pag', slug: 'pag', population: 3846 },
  { name: 'Kolan', slug: 'kolan', population: 796 },
  { name: 'Lun', slug: 'lun', population: 267 },
  { name: 'Nin', slug: 'nin', population: 2744 },
  { name: 'Biograd na Moru', slug: 'biograd-na-moru', population: 5259 },
  { name: 'Benkovac', slug: 'benkovac', population: 10467 },
  { name: 'Obrovac', slug: 'obrovac', population: 4323 },
  { name: 'Gracac', slug: 'gracac', population: 4380 },
  { name: 'Knin', slug: 'knin', population: 15407 },
  { name: 'Drnis', slug: 'drnis', population: 8313 },
  { name: 'Vodice', slug: 'vodice', population: 8875 },
  { name: 'Tribunj', slug: 'tribunj', population: 1536 },
  { name: 'Tisno', slug: 'tisno', population: 1282 },
  { name: 'Pirovac', slug: 'pirovac', population: 1930 },
  { name: 'Murter', slug: 'murter', population: 2044 },
  { name: 'Betina', slug: 'betina', population: 673 },
  { name: 'Jezera', slug: 'jezera', population: 845 },
  { name: 'Sibenik', slug: 'sibenik', population: 46332 },
  { name: 'Skradin', slug: 'skradin', population: 3825 },
  { name: 'Rogoznica', slug: 'rogoznica', population: 2391 },
  { name: 'Primošten', slug: 'primosten', population: 2828 },
  { name: 'Trogir', slug: 'trogir', population: 13192 },
  { name: 'Marina', slug: 'marina', population: 4478 }
];

export const croatiaExpanded = {
  code: 'HR',
  name: 'Croatia',
  slug: 'croatia',
  population: 3888529,
  topCities: [
    { name: 'Zagreb', slug: 'zagreb', population: 790017 },
    ...croatiaAdditionalCities
  ]
};
